import React from 'react';
import { useFormik } from 'formik';
import { postDataToTheServer, putDataToTheServer } from '../../../helpers/api';
import AppURL from '../../../constants/AppURL';
import { ToastError, ToastSuccess, ToastWarning } from '../../../constants/Toast';
import Container from '../../../constants/Container';
import SecHeading from '../../../constants/SecHeading';
import { Grid } from '@mui/material';
import InputTextBox from '../../../constants/InputTextBox';
import NepaliInputBox from '../../../constants/NepaliInputBox';
import { handleChangeDate, handleChangePhone, handleNepaliInputChange } from '../../../helpers/handleChange';
import { EndBaseLine } from '../../../constants/AppSpace';
import { Button } from '../../../constants/Button';
import { CgPassword } from 'react-icons/cg';
import { GrMail } from 'react-icons/gr';
import { NepNowDateFormat } from '../../../constants/DateFormat';
import { readerValidationSchema } from '../../../helpers/validation';

interface ReaderAddFormViewProps {
    handleFormSuccess: () => void;
}
const ReaderCreateView: React.FC<ReaderAddFormViewProps> = ({ handleFormSuccess }) => {
    const nepaliCurData = NepNowDateFormat();

    const initialValues = {
        reader_name: "",
        reader_name_nep: "",
        reader_add: "",
        reader_add_nep: "",
        reader_phone: "",
        reader_date: nepaliCurData||"",
        branch: "",
        reader_pass: "",
        email: "",
        username:"",
        user_no: "",
    };
    const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        validationSchema: readerValidationSchema,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            const formData = new FormData();
                Object.keys(values).forEach((key) => {
                    const value = (values as Record<string, any>)[key];
                    // Check if the value exists and is not an empty string
                    if (value !== undefined && value !== null && value !== "") {
                        formData.append(key, value);
                    }
                });
                try {
                    await postDataToTheServer(AppURL.FrontOfficeURL + "front/reader/create/new/view/", formData).then((res) => {
                        if (res?.status === 201) {
                            ToastSuccess({ message: res?.message });
                            action.resetForm();
                            handleFormSuccess();
                        } else if (res?.status === 400) {
                            ToastWarning(res?.message);
                        } else {
                            ToastError({message: "Something Error "})
                        }
                    });
                } catch (error) {
                    console.log(error);
                }
        },
    });
    return (
        <Container padding={true}>
            <form onSubmit={handleSubmit}>
                <SecHeading type='add' label='Reader Add' />
                <Grid container columnSpacing={3} rowSpacing={0.8}>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <InputTextBox
                            type='text'
                            name='reader_name'
                            label='Reader Name'
                            handleChange={handleChange}
                            value={values.reader_name}
                            error={errors.reader_name}
                            handleBlur={handleBlur}
                            touched={touched.reader_name}
                            required={true}
                            placeholder='Enter Reader Name'
                        />
                    </Grid>

                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <NepaliInputBox
                            label='Reader Name(Nepali)'
                            name='reader_name_nep'
                            value={values.reader_name_nep}
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'reader_name_nep' })}
                            handleBlur={handleBlur}
                            error={errors.reader_name_nep}
                            placeholder='Enter Reader nepali name'
                            touched={touched.reader_name_nep}
                            required={true}
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <InputTextBox
                            type='text'
                            name='reader_add'
                            label='Address'
                            handleChange={handleChange}
                            value={values.reader_add}
                            error={errors.reader_add}
                            handleBlur={handleBlur}
                            touched={touched.reader_add}
                            required={false}
                            placeholder='Enter Address'
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <NepaliInputBox
                            label='Reader Address(Nepali)'
                            name='reader_add_nep'
                            value={values.reader_add_nep}
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'reader_add_nep' })}
                            required={false}
                            handleBlur={handleBlur}
                            error={typeof errors.reader_add_nep === 'string' ? errors.reader_add_nep : undefined}
                            placeholder='Enter Reader Address(Nepali)'
                            touched={touched.reader_add_nep}
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <InputTextBox
                            type='text'
                            name='reader_phone'
                            label='Phone No.'
                            handleChange={(e) => handleChangePhone(e, { setFieldValue, name: 'reader_phone' })}
                            value={values.reader_phone}
                            error={errors.reader_phone}
                            handleBlur={handleBlur}
                            touched={touched.reader_phone}
                            required={false}
                            placeholder='XXX-XXXXXXX'
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <InputTextBox
                            type='text'
                            name='reader_date'
                            label='Reader Date'
                            handleChange={(e) => handleChangeDate(e, { setFieldValue, name: 'reader_date' })}
                            value={values.reader_date}
                            error={typeof errors.reader_date === 'string' ? errors.reader_date : undefined}
                            touched={touched.reader_date ? true : false} 
                            handleBlur={handleBlur}
                            required={true}
                            placeholder='XXXX/XX/XX'
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <InputTextBox
                            type='email'
                            name='email'
                            prefix={<GrMail />}
                            label='E-mail'
                            handleChange={handleChange}
                            value={values.email}
                            error={errors.email}
                            handleBlur={handleBlur}
                            touched={touched.email}
                            required={true}
                            placeholder='example@gmail.com'
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <InputTextBox
                            type='text'
                            name='username'
                            label='Username'
                            handleChange={handleChange}
                            value={values.username}
                            error={errors.username}
                            handleBlur={handleBlur}
                            touched={touched.username}
                            required={true}
                            placeholder='Enter Username'
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <InputTextBox
                            type='password'
                            name='reader_pass'
                            prefix={<CgPassword />}
                            label='Password'
                            handleChange={handleChange}
                            value={values.reader_pass}
                            error={errors.reader_pass}
                            handleBlur={handleBlur}
                            touched={touched.reader_pass}
                            required={true}
                            placeholder='Enter Password'
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <EndBaseLine top={18}>
                            <Button btn_type='save' type='submit' el='button' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>

        </Container>
    )
}

export default ReaderCreateView